"use client";
import React from "react";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

const CustomInput = React.forwardRef(
  ({ label, className, labelClassName, isInvalid = false, errorMessage = "", value = "", onChange, ...props }, ref) => {
    return (
      <div className={cn("relative mb-5", className)}>
        {/* Input Field */}
        <Input
          ref={ref}
          value={value}
          onChange={onChange}
          className={cn(
            "peer w-full h-[50px] px-3 py-2 border border-gray-300 rounded-[8px] text-black focus:outline-none focus:border-blue-500",
            isInvalid && "border-red-500 focus:border-red-500"
          )}
          placeholder=" " // Ensures label moves up when input has value
          {...props}
        />
        
        {/* Floating Label */}
        <label
          className={cn(
            "absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500 transition-all duration-200 pointer-events-none bg-white px-1 text-[14px]",
            value
              ? "top-[6px] text-xs text-gray-700 bg-white" // Moves up if value exists
              : "peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:text-gray-500 peer-placeholder-shown:text-[14px]",
            "peer-focus:top-[6px] peer-focus:text-xs peer-focus:text-gray-700 peer-focus:bg-white",
            labelClassName
          )}
        >
          {label}
        </label>

        {/* Error Message */}
        {isInvalid && (
          <p className="text-red-600 text-[10px] absolute bottom-[-18px] left-[12px]">
            {errorMessage}
          </p>
        )}
      </div>
    );
  }
);

CustomInput.displayName = "CustomInput";

export default CustomInput;
